/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Material UI
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

// Helpers
import { useAuth } from '../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';
import { trackEvent } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getFeatureFlag } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const DesktopBillingDetailGuest = () => {
    const dispatch = useDispatch();

    const [hideBillingDetails, setHideBillingDetails] = useState(false);
    const hideBillingDetailsFeatureFlag = useSelector(getFeatureFlag('is-hiding-billing-details-on-order-details'));

    const { loginByRedirect } = useAuth();

    const toggleBillingView = () => {
        if (hideBillingDetails) {
            setHideBillingDetails(false);
        } else {
            setHideBillingDetails(true);
        }
    };

    const handleSignInClicked = (method) => {
        if (method === 'signin') {
            loginByRedirect();
        }
    };

    if (hideBillingDetailsFeatureFlag) return <></>;

    return (
        <>
            <Card className="margin-top delivery-info">
                <div
                    className="toggle-guest-billing-button dark-border gray-bg"
                    onKeyDown={() => { }}
                    role="button"
                    tabIndex={-1}
                    onClick={() => toggleBillingView()}
                >
                    <span>{`${hideBillingDetails ? 'Expand' : 'Collapse'} Billing Details`}</span>
                    <img alt="collapse" src={hideBillingDetails ? 'https://images.contentstack.io/v3/assets/blt95e0138311135214/blt8434534d6387623f/5fe39f2e396e65084a9e7118/down-arrow.svg' : 'https://images.contentstack.io/v3/assets/blt95e0138311135214/blt683a6cec1ac5e736/5fe39f45e7fdff751b793746/up-arrow.svg'} />
                </div>
                {!hideBillingDetails && (
                    <CardContent className={`padding-10 ${hideBillingDetails ? 'hidden' : ''}`}>
                        <Grid container className="desktop-billing-guest" justify="center">
                            <Grid item>
                                <Typography>
                                    <span
                                        role="button"
                                        tabIndex={-1}
                                        onKeyDown={() => { }}
                                        onClick={async () => {
                                            handleSignInClicked('signin');
                                            dispatch(trackEvent({
                                                eventCategory: 'Sign In', eventAction: 'Login', eventLabel: 'Logon_From_Guest-Order-Tracking_Redirect|<<pageType>>',
                                            }));
                                        }}
                                    >
                                        Register or Sign-In
                                    </span>
                                    {' '}
                                    to access billing details.
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                )}
            </Card>
        </>
    );
};

export default DesktopBillingDetailGuest;
